module.exports = __webpack_public_path__ + "static/ochs-neurology-99fd49bb7fd3434a685d7a849c516d89.jpg";